// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"b37c5752","239":"a8659337","359":"d876f711","431":"06b964b3","464":"a8659337","869":"d876f711"}[chunkId] + ".chunk.css";
};